module.exports = __webpack_public_path__ + "static/04-5ff76576a2aab6ecc3b5cf532276232a.jpeg";